module.exports = __webpack_public_path__ + "img/plan.b55e64b.png";